import { useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  useTheme,
  NumberField,
} from "react-admin";
import InventoryHistoryExpandList from "../../components/inventoryHistories/expand/InventoryHistoryExpandList";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import MyDatagridBody from "../../components/common/MyDatagridBody";
import InventoryHistoryFooterList from "../../components/inventoryHistories/footer/InventoryHistoryFooterList";
import inventoryHistoryFilterList from "../../components/inventoryHistories/filter/inventoryHistoryFilterList";
import ManualReportList from "../../components/reports/ManualReportList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const InventoryHistoryList = () => {
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters({
      start_date: firstDate,
      end_date: lastDate,
    });
  const [theme] = useTheme("light");

  const list = useMemo(
    () => (
      <ManualReportList
        storeKey={false} // Disabling Parameters Persistence
        title="mine.list_title.inventory_history"
        empty={false}
        actions={<DownloadAction field="products.code" order="ASC" />}
        filters={inventoryHistoryFilterList(permissions)}
        filterDefaultValues={filterDefaultValues}
        requiredFilters={["start_date", "end_date"]}
        queryOptions={{ meta: { sort: ["products.code ASC"] } }} // overide default sort
        sx={{
          flexDirection: "column",
        }}
      >
        <DatagridConfigurable
          body={
            <MyDatagridBody
              footer={
                <InventoryHistoryFooterList
                  canSeeCompanyColumn={canSeeCompanyColumn}
                />
              }
            />
          }
          bulkActionButtons={false}
          expand={<InventoryHistoryExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField source="company.alias" label="mine.label.depo" />
          ) : null}
          <TextField source="code" label="mine.label.product_code" />
          <NumberField source="initial" label="mine.label.initial" />
          <NumberField
            source="initial_value"
            label="mine.label.initial_value"
          />
          <NumberField source="total_in" label="mine.label.total_in" />
          <NumberField source="total_in_value" label="mine.label.value_in" />
          <NumberField source="total_out" label="mine.label.total_out" />
          <NumberField source="total_out_value" label="mine.label.value_out" />
          <NumberField source="final" label="mine.label.final" />
          <NumberField source="final_value" label="mine.label.final_value" />
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [theme, permissions, canSeeCompanyColumn, filterDefaultValues]
  );

  return list;
};

export default InventoryHistoryList;
